import React from "react";
import { Container } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import img1 from '../assets/img/1.png'



import DataProvider from '../services/DataProvider'

const Slider = () => {

    const [sliderImg, setSliderImg] = React.useState([])

    React.useEffect(() => {

        DataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            if(response.data.arquivos)
            if (typeof response.data.arquivos.filter === 'function') {
                setSliderImg(response.data.arquivos.filter((v) => v.IMG_TIPO === 'C'))
            }

        })

    }, []);


    return (
        <>

            <Container>
                <Carousel autoPlay infiniteLoop={true} showArrows={true} showStatus={false} showThumbs={false} >
                    {
                        sliderImg.map((v, i) => {
                            if (v.IMG_CAMINHO !== null) {
                                return (
                                    <div key={i} >

                                        <a href={v.IMG_LINK} style={{ display: 'block' }} target='_blank'>
                                            <img src={v.IMG_CAMINHO} alt={v.IMG_NOME_IMAGEM} style={{ width: '100%', height: 400 }} />
                                        </a>

                                    </div>)
                            } else {
                                return (<img src={img1} alt="" key={v.IMG_NOME_IMAGEM} />)
                            }
                        })
                    }

                </Carousel>
            </Container>
        </>
    );
};

export default Slider;